import React, { useEffect, useState } from "react";
import { useStore } from "../../stores/store";
import { LanguageDto } from "../../models/languageDto";
import { useTranslation } from "react-i18next";
import agent from "../../api/agent";
import { toast } from "react-toastify";
import { Accordion, Flag, FlagNameValues, Icon, Menu } from "semantic-ui-react";

interface Props{
  onLanguageSelected:()=>void;
}

export default function MobileLanguageSwitcher({onLanguageSelected}:Props) {
  const { commonStore } = useStore();
  const { i18n } = useTranslation("common");
  const [loading, setLoading] = useState<boolean>(true);
  const [languages, setLanguages] = useState<LanguageDto[]>();
  const [activeMenuIndex, setActiveMenuIndex] = useState<number>(-1);

  const changeLanguage = (language: string) => {
    if (commonStore.currentSurveyCode == null) {
      commonStore.setLanguage(language);
      i18n.changeLanguage(language);
    } else {
      setLoading(true);
      agent.Translations.getSurveyContent(commonStore.currentSurveyCode, language)
        .then((result) => {
          commonStore.setSurveyConentTranslations(result);
          commonStore.setLanguage(language);
          i18n.changeLanguage(language);
          onLanguageSelected();
        })
        .catch(() => {
          toast.error("Failed to load selected language");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    setLoading(true);
    agent.Surveys.languages(commonStore.currentSurveyId)
      .then((result) => {
        setLanguages(result);
      })
      .catch(() => {
        toast.error("Failed to load languages");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [commonStore.currentSurveyId]);

  return (
    <>
      <Accordion fluid className="oasis-accordion">
        <Accordion.Title
          index={0}
          onClick={() => {
            setActiveMenuIndex(activeMenuIndex === 0 ? -1 : 0);
          }}
        >
          <Icon name="dropdown" />
          Language
        </Accordion.Title>
        <Accordion.Content active={activeMenuIndex === 0}>
          {languages &&
            languages.length > 0 &&
            languages.map((language, index) => (
              <Menu.Item
                key={index}
                className="acc-firstchild"
                as="a"
                onClick={() => {
                  changeLanguage(language.locale);
                }}
              >
                <Flag name={language.flagName as FlagNameValues} />
                {language.name}
              </Menu.Item>
            ))}
        </Accordion.Content>
      </Accordion>
    </>
  );
}
